import { Component, Input, signal } from '@angular/core';

@Component({
  selector: 'app-product-image',
  standalone: true,
  template: `
    @if (currentSrc() && !failed()) {
      <img
        [src]="currentSrc()"
        [alt]="alt"
        [class]="imgClass"
        [attr.loading]="priority ? null : 'lazy'"
        [attr.fetchpriority]="priority ? 'high' : null"
        (error)="failed.set(true)"
      />
    } @else {
      <div
        class="flex h-full w-full flex-col items-center justify-center gap-1.5 bg-creamdark text-tandark"
        role="img"
        [attr.aria-label]="alt || 'No photo available'"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="h-1/3 w-1/3 max-h-10 max-w-10">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M2.25 15.75l5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909M3.75 4.5h16.5a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5V6a1.5 1.5 0 0 1 1.5-1.5Zm10.5 5.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
          />
        </svg>
        @if (label) {
          <p class="text-xs font-medium">{{ label }}</p>
        }
      </div>
    }
  `,
})
export class ProductImageComponent {
  readonly currentSrc = signal<string | null | undefined>(null);
  readonly failed = signal(false);

  @Input() set src(value: string | null | undefined) {
    this.currentSrc.set(value);
    this.failed.set(false);
  }

  @Input() alt = '';
  @Input() imgClass = 'h-full w-full object-cover';
  @Input() label: string | null = null;
  /** Skip lazy-load and hint `fetchpriority=high` — only the page LCP image. */
  @Input() priority = false;
}
